// Extracted from the web lap-brief dependency graph. Shared by API and web.
import { matchDetailedTurnPhases } from '../../index.js';
import { type TurnPhaseMatch } from '../../index.js';
import { type MyChronSessionExport } from './telemetrySession.js';
import { speedKphAtTime } from './telemetrySession.js';
import { TURN_TRAVERSE_MAX_DISTANCE_M } from '../../index.js';
export function smoothedSpeedKphAtTime(session: MyChronSessionExport, timecodeMs: number) {
  const speeds = [-100, -50, 0, 50, 100]
    .map((offset) => speedKphAtTime(session, timecodeMs + offset))
    .filter((speed): speed is number => speed !== null)
    .sort((left, right) => left - right);
  return speeds.length ? speeds[Math.floor(speeds.length / 2)]! : null;
}

export { TURN_TRAVERSE_MAX_DISTANCE_M };
export { matchDetailedTurnPhases };
export { type TurnPhaseMatch };
